// base
import React from 'react';

// style
import { StyledCenterModal, StyledFooter } from './style';

// components
import { TextButton } from 'components';

// libraries
import { type ButtonProps, Modal, type ModalProps } from '@mui/material';

interface FooterButtonProps extends ButtonProps {
  children?: React.ReactNode;
}

export interface CenterModalProps extends Omit<ModalProps, 'onClose' | 'children'> {
  modalTitle?: React.ReactNode;
  onClose: () => void;
  showCloseBtn?: boolean;
  showTitle?: boolean;
  titleStyle?: React.CSSProperties;
  isBackClose?: boolean;
  width?: number;
  height?: number;
  noFooter?: boolean;
  footer?: React.ReactNode;
  okButtonProps?: FooterButtonProps;
  closeButtonProps?: FooterButtonProps;
  isSingleFooter?: boolean;
  children?: React.ReactNode;
}

export const CenterModal: React.FC<CenterModalProps> = ({
  modalTitle = 'Alarm',
  children,
  onClose,
  showCloseBtn = true,
  noFooter = true,
  showTitle = true,
  titleStyle,
  isBackClose = false,
  isSingleFooter = false,
  width = 400,
  height,
  footer,
  okButtonProps,
  closeButtonProps,
  ...props
}) => {
  const handleClose = (_: {}, r: 'backdropClick' | 'escapeKeyDown') => {
    if (isBackClose && r && r === 'backdropClick') return;

    onClose();
  };

  return (
    <Modal onClose={handleClose} disableScrollLock {...props}>
      <StyledCenterModal width={width} height={height}>
        {showTitle && (
          <div className="center-title" style={titleStyle}>
            <h2>{modalTitle}</h2>
            {showCloseBtn && <TextButton className="center-title-close" onClick={onClose} />}
          </div>
        )}
        {children}

        {!noFooter && (
          <div className="center-footer">
            {footer ||
              (isSingleFooter ? (
                <StyledFooter>
                  <TextButton
                    variant="contained"
                    {...closeButtonProps}
                    onClick={(e) => closeButtonProps?.onClick?.(e)}
                  >
                    {closeButtonProps?.children || 'Close'}
                  </TextButton>
                </StyledFooter>
              ) : (
                <StyledFooter>
                  <TextButton
                    className="close-btn"
                    {...closeButtonProps}
                    onClick={(e) => closeButtonProps?.onClick?.(e)}
                  >
                    {closeButtonProps?.children || 'Close'}
                  </TextButton>
                  <TextButton
                    variant="contained"
                    {...okButtonProps}
                    onClick={(e) => okButtonProps?.onClick?.(e)}
                  >
                    {okButtonProps?.children || 'Save'}
                  </TextButton>
                </StyledFooter>
              ))}
          </div>
        )}
      </StyledCenterModal>
    </Modal>
  );
};
